import * as tslib_1 from "tslib";
import { AriaDescriber, FocusMonitor, } from '@angular/cdk/a11y';
import { Directionality } from '@angular/cdk/bidi';
import { Overlay, ScrollDispatcher, } from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import { ElementRef, NgZone, ViewContainerRef, } from '@angular/core';
import { MatTooltip, MatTooltipDefaultOptions, } from '@angular/material/tooltip';
var UiTooltipDirective = /** @class */ (function (_super) {
    tslib_1.__extends(UiTooltipDirective, _super);
    function UiTooltipDirective(_ref, _overlay, _scrollDispatcher, _viewContainerRef, _ngZone, _platform, _ariaDescriber, _focusMonitor, _scrollStrategy, _dir, _defaultOptions) {
        var _this = _super.call(this, _overlay, _ref, _scrollDispatcher, _viewContainerRef, _ngZone, _platform, _ariaDescriber, _focusMonitor, _scrollStrategy, _dir, _defaultOptions) || this;
        _this._ref = _ref;
        _this.position = 'above';
        return _this;
    }
    return UiTooltipDirective;
}(MatTooltip));
export { UiTooltipDirective };
